'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import ViralTrackingPixel from 'viral-links-lib/viral-tracking/ViralTrackingPixel';
export default class FreemiumViralTrackingPixel extends Component {
  render() {
    const {
      embedded,
      portalId,
      viralLinkType
    } = this.props;
    const linkType = embedded ? `${viralLinkType}-embedded` : `${viralLinkType}`;
    return /*#__PURE__*/_jsx(ViralTrackingPixel, {
      portalId: portalId,
      viralLinkType: linkType,
      isExternalLink: embedded
    });
  }

}